// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    // Duration
    for: {
        id: 'recipes-duration.for',
        defaultMessage: 'For',
        description: '"For" from e.g. "For 15 min"'
    },
    _30seconds: {
        id: 'recipes-duration._30seconds',
        defaultMessage: '30 seconds'
    },
    _1minute: {
        id: 'recipes-duration._1minute',
        defaultMessage: '1 minute'
    },
    _3minutes: {
        id: 'recipes-duration._3minutes',
        defaultMessage: '3 minutes'
    },
    _5minutes: {
        id: 'recipes-duration._5minutes',
        defaultMessage: '5 minutes'
    },
    _10minutes: {
        id: 'recipes-duration._10minutes',
        defaultMessage: '10 minutes'
    },
    _15minutes: {
        id: 'recipes-duration._15minutes',
        defaultMessage: '15 minutes'
    },
    indefinitely: {
        id: 'recipes-duration.indefintely',
        defaultMessage: 'Indefinitely'
    },

    // Change Plug On/Off
    plugLabel: {
        id: 'recipes-plug.plug-label',
        defaultMessage: 'Turn',
        description: 'label for the dropdown showing the different states a user can choose for the plugs (on/off)'
    },
    plugOn: {
        id: 'recipes-plug.plug-on',
        defaultMessage: 'On',
        description: 'A state of a plug that can be selected in the dropdown'
    },
    plugOff: {
        id: 'recipes-plug.plug-off',
        defaultMessage: 'Off',
        description: 'A state of a plug that can be selected in the dropdown'
    },

    // Change Light On/Off
    lightLabel: {
        id: 'recipes-light.light-label',
        defaultMessage: 'Turn',
        description: 'label for the dropdown showing the different states a user can choose for the lights (on/off)'
    },
    lightOn: {
        id: 'recipes-light.light-on',
        defaultMessage: 'On',
        description: 'A state of a light that can be selected in the dropdown'
    },
    lightOff: {
        id: 'recipes-light.light-off',
        defaultMessage: 'Off',
        description: 'A state of a light that can be selected in the dropdown'
    },
    // Change Heating Mode
    heatingModeLabel: {
        id: 'recipes-heating.heating-mode-label',
        defaultMessage: 'Set to',
        description: 'label for the dropdown showing the different heating modes a user can choose'
    },
    heatingScheduleMode: {
        id: 'recipes-heating.heating-schedule-mode',
        defaultMessage: 'Schedule',
        description: 'Heating Schedule Mode'
    },
    heatingManualMode: {
        id: 'recipes-heating.heating-manual-mode',
        defaultMessage: 'Manual',
        description: 'Heating Manual Mode'
    },
    heatingOffMode: {
        id: 'recipes-heating.heating-off-mode',
        defaultMessage: 'Off',
        description: 'Heating Off Mode'
    },
    heatingBoostMode: {
        id: 'recipes-heating.heating-boost-mode',
        defaultMessage: 'Boost',
        description: 'Heating Boost Mode'
    },
    heatingTargetLabel: {
        id: 'recipes-heating.heating-target-label',
        defaultMessage: 'Set target to',
        description: 'label for the range of temperatures a user can choose'
    },
    heatingBoostLabel: {
        id: 'recipes-heating.heating-boost-label',
        defaultMessage: 'For duration',
        description: 'label for the boost duration a user can choose'
    },
    heatingBoostDuration030: {
        id: 'recipes-heating.heating-boost-duration-030',
        defaultMessage: '30 minutes'
    },
    heatingBoostDuration1: {
        id: 'recipes-heating.heating-boost-duration-1',
        defaultMessage: '1 hour'
    },
    heatingBoostDuration2: {
        id: 'recipes-heating.heating-boost-duration-2',
        defaultMessage: '2 hours'
    },
    heatingBoostDuration3: {
        id: 'recipes-heating.heating-boost-duration-3',
        defaultMessage: '3 hours'
    },
    heatingBoostDuration4: {
        id: 'recipes-heating.heating-boost-duration-4',
        defaultMessage: '4 hours'
    },
    heatingBoostDuration5: {
        id: 'recipes-heating.heating-boost-duration-5',
        defaultMessage: '5 hours'
    },
    heatingBoostDuration6: {
        id: 'recipes-heating.heating-boost-duration-6',
        defaultMessage: '6 hours'
    }
});



// WEBPACK FOOTER //
// ./src/core/utils/recipes/intl.js